import ProtectedRoute from 'components/ProtectedRoute'
import useFlag from 'hooks/useFlag'
import { useOrderingAccess } from 'hooks/useOrderingAccess'
import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import OperationsCenterPosConfigurations from 'scenes/OperationsCenter/PosConfigurations'

// `/pos_configurations` is the canonical route for the menu-grouped error
// view. Phase 2 split it out of `/locations#menu_errors` per the 2026-05-01
// thread + Figma 432:2419. Gated on the `operations-center` flag (invisible
// to un-migrated merchants) AND `supportsMenuErrors` (Toast-only today, see
// MENU_ERRORS_PROVIDERS — DATA-5395), so a non-Toast merchant typing the URL
// falls back to a redirect rather than landing on an empty Toast-centric page.
const PosConfigurations = () => {
  const operationsCenterEnabled = useFlag('operations-center', false)
  const { supportsMenuErrors } = useOrderingAccess()

  if (!operationsCenterEnabled || !supportsMenuErrors) {
    return <Redirect to="/" />
  }

  return (
    <Switch>
      <ProtectedRoute
        redirect="/"
        accessType="access"
        resource="Locations"
        exact
        path="/pos_configurations"
        component={OperationsCenterPosConfigurations}
      />
    </Switch>
  )
}

export default PosConfigurations
